import React, { useState , useEffect } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  TextField,
  Fade,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import Alert from '@material-ui/lab/Alert';

// styles
import useStyles from "./styles";

// logo
import google from "../../images/google.svg";

// context
import { useUserDispatch, useUserState, loginUser , setAmazonCredentials, forgotPassword } from "../../context/UserContext";
import { usePopupState , usePopupDispatch } from "../../context/PopupContext";

function getParameterByName(name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function ForgotPassword(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();
  var popupDispatch = usePopupDispatch();
  var { err, notification } = usePopupState();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [loginValue, setLoginValue] = useState("");

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <Typography className={classes.logotypeText}>
          Forgot Password
        </Typography>
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <React.Fragment>
            {/* <Typography variant="subtitle1" className={classes.greeting}>
              Enter your Email Address to receive reset link.
            </Typography> */}
            {/* <div className={classes.formDivider} /> */}
            {/* <div className={classes.formDividerContainer}>
              <div className={classes.formDivider} />
              <Typography className={classes.formDividerWord}>or</Typography>
              <div className={classes.formDivider} />
            </div> */}
            <TextField
              id="email"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={loginValue}
              onChange={(e) => setLoginValue(e.target.value)}
              margin="normal"
              placeholder="Email Address"
              type="email"
              fullWidth
            />
            <div className={classes.formButtons}>
              {isLoading ? (
                <CircularProgress size={26} className={classes.loginLoader} />
              ) : (
                <Button
                  disabled={
                    loginValue.length === 0
                  }
                  onClick={() => {
                    forgotPassword(
                      {email:loginValue},
                      popupDispatch,
                      props.history,
                      setIsLoading,
                    )
                  }}
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Submit
                </Button>
              )}
              <Button
                color="primary"
                size="large"
                className={classes.forgetButton}
                onClick={() => props.history.push("/login")}
              >
                Back to Login
              </Button>
            </div>
          </React.Fragment>
        </div>
      </div>
      {
        notification ? 
          <Alert severity="success" style={{position:'absolute', bottom: 30, left: '48%'}}>{notification}</Alert>
        :
        <></>
      }      
      {
        err ? 
          <Alert severity="error" style={{position:'absolute', bottom: 30, left: '48%'}}>{err}</Alert>
        :
        <></>
      }     
    </Grid>
  );
}

export default withRouter(ForgotPassword);
